import i18n from "../../../../constants/i18n";
import { USER_AI_DESCRIPTIONS_HEADERS } from "../../../../constants/table-custom-headers/User";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import getAIDescriptionsStore from "../../../../stores/user-store/ai-descriptions-store";

const UserAIDescriptionsData = withLiteObserverAndTheme(() => {
  const userAIDescriptions = getAIDescriptionsStore().userAIDescriptions.get();
  return (
    <Et3Table
      columns={USER_AI_DESCRIPTIONS_HEADERS}
      rows={userAIDescriptions}
      title={i18n.get("AI_DESCRIPTIONS")}
      shouldBeFlagged={false}
      titleKey={"AI_DESCRIPTIONS"}
      emptyMessageKey={"NO_DESCRIPTION"}
    />
  );
});

export default UserAIDescriptionsData;
